<template>
    <div class="homePage">
        <!-- <Header /> -->
        <div>
            <img style="width:100%" src="@/assets/image/signupbanner.png" alt="" />
            <div class="tabbox">
                <div :class="tab==1?'active':'normal'" @click="change(1)">个人报名</div>
                <div style="color:#ccc;font-size:25px;">|</div>
                <div :class="tab==2?'active':'normal'" @click="change(2)">企业报名</div>
            </div>
        </div>
        <Signle  v-if="tab==1"></Signle>
        <Business  v-else></Business>
        <Footer />
    </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/index";
import Signle from './single1.vue';
import Business from './business1.vue'
export default {
    components: { Footer, Header, Signle, Business },
    data() {
        return {
           tab:1,
           step:1
        };
    },
    methods: {
      change(num){
          this.tab=num
          if(num==1){

          }else{

          }
      }
    },
};
</script>

<style lang="scss" scoped>
.tabbox{
    width:267px;
    margin:auto;
    margin-top:50px;
    display:flex;
    justify-content:space-between;
    .active{
        cursor:pointer;
        color:rgb(189,31,32);
        padding-bottom:10px;
        border-bottom:2px solid rgb(189,31,32)
    }
    .normal{
        cursor:pointer;
        color:black;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Signup/index.vue